import type { RequestConfig } from '@customTypes/index';
import type { ArtistPhotoTag, PhotoItemDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type GetArtistProfilePhotoListRequest = {
  profileId: string;
  tag?: ArtistPhotoTag;
};

export type GetArtistProfilePhotoListParams =
  RequestConfig<GetArtistProfilePhotoListRequest>;

export const getArtistProfilePhotoList = async ({
  params,
  config
}: GetArtistProfilePhotoListParams) =>
  api.get<PhotoItemDto[]>(`/api/photos/artist/${params.profileId}`, {
    ...config,
    params: { tags: params.tag }
  });
